import React from "react";
import "./checkout-details.scss";
import { useSelector } from "react-redux";
import useShippingLabel from 'hooks/useShippingLabel';

const CheckoutDetails = () => {
  const { isFollowedEbtPayment } = useSelector(({ checkout }) => checkout);
  const { storeDetails } = useSelector(({ store }) => store);

  const { shippingLabelLower } = useShippingLabel()
  
  const shippingMethod =
    storeDetails?.allow_pickup === "1" && storeDetails?.allow_delivery === "1"
      ? `pickup or ${shippingLabelLower}`
      : storeDetails?.allow_pickup === "1"
      ? "pickup"
      : storeDetails?.allow_delivery === "1"
      ? shippingLabelLower
      : "";
  return (
    <div className="checkout-details-section">
      <div className="container">
        <div className="page-title">
          <h1>Checkout</h1>
        </div>
        <div className="enter-code-coupon">
          <p>
            {isFollowedEbtPayment ? (
              <span style={{ fontSize: "1.4rem", fontWeight: "bold" }}>
                Your EBT payment is successful. Complete the remaining amount
                payment by credit card to place an order.
              </span>
            ) : (
              <span>
                Choose {shippingMethod}, date time, apply available coupons and
                place order
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
export default CheckoutDetails;
